import { Navigate, Outlet } from "react-router-dom";
import { getUserType } from "../../utils/appUtils";

const getRedirectPath = (role) => {
    switch (role) {
      case "admin":
        return "/all-events";
      case "guest":
        return "/";
      default:
        return "/";
    }
  };

/**
 * ProtectedRoute — Guards pages based on allowed roles
 * If user is not an organizer or user, redirects to /login.
 * If user is an organizer, redirects to /dashboard.
 * If user is a normal user, redirects to /.
 */
const ProtectedRoute = ({ allowedRoles }) => {
 const activeRole = getUserType();

  // Role not allowed
  if (allowedRoles && !allowedRoles.includes(activeRole)) {
    return <Navigate to={getRedirectPath(activeRole)} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;